import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AttachmentType } from './model/attachmentType';

@Component({
    selector: 'app-assessment-registration-application',
    templateUrl: './assessmentRegistration.component.html',
    styleUrls: ['./application.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssessmentRegistrationApplicationComponent implements OnInit {
  @Input() application: any;
  attachmentType = AttachmentType;

  name!: string;
  submittedAt: any;
  preentryNumber!: number;


  constructor() { }

  ngOnInit() {

    this.name = this.application.name;
    this.preentryNumber = this.application.preregNumber;
    this.submittedAt = this.application.submittedDate;

  }

}

